import { all } from 'redux-saga/effects';

import authSagas from './slices/auth/sagas';
import companySagas from './slices/company/sagas';
import interventionSagas from './slices/intervention/sagas';
import treeTradeSagas from './slices/treetrade/sagas';
import workerSagas from './slices/worker/sagas';

function* rootSagas() {
  yield all([
    authSagas,
    workerSagas,
    companySagas,
    interventionSagas,
    treeTradeSagas,
  ]);
}

export default rootSagas;
